import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, CardText } from 'material-ui/Card';
import compose from 'recompose/compose'; 
import ViewTitle from '../layout/ViewTitle';
import Title from '../layout/Title';
import { crudGetOne as crudGetOneAction, crudUpdate as crudUpdateAction } from 'actions/dataActions';
import DefaultActions from './EditActions';

export class Edit extends Component {
  static propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element.isRequired,
    crudGetOne: PropTypes.func.isRequired,
    crudUpdate: PropTypes.func.isRequired,
    data: PropTypes.object,
    hasDelete: PropTypes.bool,
    hasShow: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    editBackendPath: PropTypes.string.isRequired,
    redirectPath: PropTypes.string,
    updateDataOnMount: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    updateDataOnMount: true,
    handleSubmit: (props, basePath) => (record) => {
        props.crudUpdate(props.resource, props.id,
          record, props.data, props.editBackendPath, basePath);
    },
  };

  componentDidMount() {
    if (this.props.updateDataOnMount)
      this.updateData();
  }

  getBasePath() {
    if (this.props.redirectPath)
      return this.props.redirectPath;
    const { location } = this.props;
    return location.pathname.split('/').slice(0, -1).join('/');
  }

  updateData(resource = this.props.resource, id = this.props.id) {
    let getOneApi = this.props.editBackendPath;
    if (this.props.detailBackendPath) {
      getOneApi = this.props.detailBackendPath;
    }

    if (this.props.customFetch) {
      this.props.customFetch(id);
    } else {
      this.props.crudGetOne(resource, id, getOneApi);
    }
  }

  render() {
    const {
      actions = <DefaultActions />, children, data, hasDelete, hasShow, id, isLoading, resource, title
    } = this.props;
    const basePath = this.props.basePath || this.getBasePath();
    const defaultTitle = `${resource} ${id}`;

    const titleElement = data ? <Title title={title} record={data} defaultTitle={defaultTitle}/> : '';

    return (
      <div className="edit-page">
        <Card style={{ opacity: isLoading ? 0.8 : 1 }}>
          {actions && React.cloneElement(actions, {
            basePath,
            showPath: this.props.showPath || '',
            data,
            hasDelete,
            hasShow,
            resource,
          })}
          <ViewTitle title={titleElement}/>
          {data && React.cloneElement(children, {
            onSubmit: this.props.handleSubmit(this.props, basePath),
            resource,
            record: data,
          })}
          {!data && <CardText>&nbsp;</CardText>}
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    id: decodeURIComponent(props.match.params.id),
    data: state.admin[props.resource] && state.admin[props.resource].data ? state.admin[props.resource].data[decodeURIComponent(props.match.params.id)]:null,
    isLoading: state.admin.loading > 0,
  };
}

const enhance = compose(
  connect(
    mapStateToProps,
    { crudGetOne: crudGetOneAction, crudUpdate: crudUpdateAction },
  ),
);

export default enhance(Edit);



// WEBPACK FOOTER //
// ./src/components/detail/Edit.js